import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import uniq from 'lodash.uniq'

const VISIBLE_POSITION = 157 // ヘッダーの高さ

export default class extends Controller {
  static targets = ['container', 'facility', 'badge']

  initialize () {
    let lastScrollPosition = 0
    let ticking = false

    window.addEventListener('scroll', () => {
      lastScrollPosition = window.scrollY
      const isEnabled = this.element.classList.contains('js-enable')

      if (!ticking && isEnabled) {
        window.requestAnimationFrame(() => {
          this.toggleVisibility(lastScrollPosition)
          ticking = false
        })

        ticking = true
      }
    })
  }

  connect () {
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    if (Array.isArray(ids) && ids.includes(this.facilityId())) {
      this.element.classList.add(`${this.className()}::bookmarked`)
    }
    this.updateBadges()
  }

  facilityId () {
    return parseInt(this.element.dataset.facilityid)
  }

  className () {
    return this.element.dataset.classname
  }

  add () {
    const id = Number(this.element.dataset.facilityid)
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    ids.push(id)
    Cookies.set('check_nursing_facility_ids', JSON.stringify(uniq(ids)))

    this.element.classList.add(`${this.className()}::bookmarked`)
  }

  remove () {
    const id = Number(this.element.dataset.facilityid)
    const ids = JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]')
    ids.splice(ids.indexOf(id), 1)
    Cookies.set('check_nursing_facility_ids', JSON.stringify(uniq(ids)))

    this.element.classList.remove(`${this.className()}::bookmarked`)
  }

  count () {
    return JSON.parse(Cookies.get('check_nursing_facility_ids') || '[]').length
  }

  update () {
    this.updateBadges()
  }

  isCountIncreased () {
    return this.badgeTargets[0]?.innerHTML !== undefined && this.count() > parseInt(this.badgeTargets[0].innerHTML)
  }

  updateBadges () {
    this.badgeTargets.forEach((badge) => { badge.innerHTML = this.count() })
  }

  toggleVisibility (scrollPosition) {
    const visibleClass = `${this.className()}::visible`
    this.containerTarget.classList.toggle(visibleClass, scrollPosition > VISIBLE_POSITION)
  }
}
